import { HttpStatusCode } from 'axios'
import { get, isString } from 'lodash/fp'

/**
 * Maps a failed `POST /scorm/auth` response to a translation key.
 *
 * The backend answers with a `message` key for every SCORM-specific failure.
 * The remaining responses have no `message`: a 404 with an empty body when the
 * request `Host` is not the SCORM domain, a 422 validation body when the LMS
 * did not provide a learner id, and a generic 500 body.
 */
export function getScormAuthErrorMessageId(
  error: unknown,
  errorStatus?: number,
): string {
  const message = get('message', error)
  if (isString(message) && message) {
    return message
  }

  if (errorStatus === HttpStatusCode.NotFound) {
    return 'scorm.error.empty'
  }

  if (
    errorStatus === HttpStatusCode.UnprocessableEntity &&
    get('messages.json.student_id', error)
  ) {
    return 'scorm.error.missing-student-id'
  }

  return 'scorm.error.default'
}
